export default __webpack_public_path__ + "static/media/logo.9e301198.png";